type ActiveDemo = { owner: symbol; interrupt: () => void };

// A page may contain several examples. Starting one pauses the previous one.
let activeDemo: ActiveDemo | undefined;

export function claimDemoPlayback(owner: symbol, interrupt: () => void) {
  const previous = activeDemo;
  activeDemo = { owner, interrupt };
  if (previous && previous.owner !== owner) previous.interrupt();
}

export function releaseDemoPlayback(owner: symbol) {
  if (activeDemo?.owner === owner) activeDemo = undefined;
}
